import appSettings from "../../settings/appSettings";

const { urls } = appSettings;

export const SMS_TERMS_URL = `${urls.core}/sms-terms-of-service`;
export const PRIVACY_NOTICE_URL = `${urls.core}/privacy-notice`;

/**
 * Strips the legal links that ride inside the SMS opt-in copy.
 *
 * Chosen shows those links on their own line under the reCAPTCHA disclaimer, so
 * its checkbox label carries the consent sentence only. Artist tours keep the
 * links in the label and do not call this.
 *
 * @param value - The resolved SMS opt-in copy.
 * @returns The copy with the legal links span removed.
 */
export function stripSmsLegalLinks(value: string) {
  return value
    .replace(/<span class="sms-optin-legal-links">[\s\S]*?<\/span>/g, "")
    .replace(/\s+/g, " ")
    .trim();
}
